import { render, staticRenderFns } from "./UserCardImage.vue?vue&type=template&id=8bedaa4e&"
import script from "./UserCardImage.vue?vue&type=script&lang=ts&"
export * from "./UserCardImage.vue?vue&type=script&lang=ts&"
import style0 from "./UserCardImage.vue?vue&type=style&index=0&id=8bedaa4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports